import React, { useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from './components/Home/Home';
import Login from './components/Login/Login';
import SignUp from './components/SignUp/SignUp';
import ContextProvider from './context/ContextProvider';
import Menu from './components/Menu/Menu';
import PrivateAuth from './PrivateAuth/PrivateAuth';
import About from './components/About/About';
import Dashboard from './components/Dashboard/Dashboard/Dashboard';
import DashboardHome from './components/Dashboard/DashboardHome/DashboardHome';
import DashboardReviews from './components/Dashboard/DashboardReviews/DashboardReviews';
import DashboardBanner from './components/Dashboard/DashboardBanner/DashboardBanner';
import DashboardSpecials from './components/Dashboard/DashboardSpecials/DashboardSpecials';
import Blogs from './components/Blogs/Blogs';
import DryAge from './components/DryAge/DryAge';
import DashboardBlogs from './components/Dashboard/DashboardBlogs/DashboardBlogs';
import AdminDashboard from './AdminDashboard/AdminDashboard';
import Gallery from './components/Gallery/Gallery';
import DashboardGallery from './components/Dashboard/DashboardGallery/DashboardGallery';
import GiftCard from './components/GiftCard/GiftCard';
import MenuKogarh from './components/Menu/MenuKogarh';
import MenuCronulla from './components/Menu/MenuCronulla';
import MenuParramatta from './components/Menu/MenuParramatta';
import BookTable from './components/BookTable/BookTable';
import ScrollToTop from './ScrollToTop/ScrollToTop';
function App() {
  useEffect(() => {
    AOS.init({
      duration: 2500,
      once: false
    });
    AOS.refresh()
  }, [])

  return (
    <div className="App">
      <Router>
        <ScrollToTop>
          <ContextProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/login" element={
                <PrivateAuth>
                  <Login />
                </PrivateAuth>
              } />
              <Route path="/signup" element={
                <PrivateAuth>
                  <SignUp />
                </PrivateAuth>
              } />
              <Route path="/menu" element={<Menu />} />
              <Route path="/menu/kogarah" element={<MenuKogarh />} />
              <Route path="/menu/cronulla" element={<MenuCronulla />} />
              <Route path="/menu/parramatta" element={<MenuParramatta />} />
              <Route path="/book-table" element={<BookTable />} />
              <Route path="/about" element={<About />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/dryage" element={<DryAge />} />
              <Route path="/gift-card" element={<GiftCard />} />
              <Route path="/dashboard" element={
                <AdminDashboard>
                  <Dashboard />
                </AdminDashboard>
              }>
                <Route path="/dashboard" element={
                  <AdminDashboard>
                    <DashboardHome />
                  </AdminDashboard>
                }>
                </Route>
                <Route path="/dashboard/banner" element={
                  <AdminDashboard>
                    <DashboardBanner />
                  </AdminDashboard>
                }>
                </Route>
                <Route path="/dashboard/specials" element={
                  <AdminDashboard>
                    <DashboardSpecials />
                  </AdminDashboard>
                }>
                </Route>
                <Route path="/dashboard/reviews" element={
                  <AdminDashboard>
                    <DashboardReviews />
                  </AdminDashboard>
                } />
                <Route path="/dashboard/blogs" element={
                  <AdminDashboard>
                    <DashboardBlogs />
                  </AdminDashboard>
                } />
                <Route path="/dashboard/gallery" element={
                  <AdminDashboard>
                    <DashboardGallery />
                  </AdminDashboard>
                } />
              </Route>
            </Routes>
          </ContextProvider>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
